import { render } from "./EditBooking.vue?vue&type=template&id=1be7a125"
import script from "./EditBooking.vue?vue&type=script&lang=js"
export * from "./EditBooking.vue?vue&type=script&lang=js"
script.render = render

export default script